import Vue from 'vue';
import Vuex from 'vuex';

import VuexPersistence from 'vuex-persist';

import userClient from '../lib/client/user';
import adminClient from '../lib/client/admin';

import initUserModule from './modules/user/';
import initAdminModule from './modules/admin/';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  key: 'gg-store',
  filter: mutation => mutation.type.startsWith('admin') && !mutation.type.toLowerCase().includes('pendingaction'),
  reducer: state => ({ ...state, admin: { ...state.admin, pendingActions: [], }, }),
});

export default new Vuex.Store({
  modules: {
    user: initUserModule(userClient),
    admin: initAdminModule(adminClient),
  },
  plugins: [vuexLocal.plugin,],
  strict: process.env.NODE_ENV !== 'production',
});
